<template>
<div class="col-md-12 px-1 mb-3">
  <div class="row g-2 mx-0">

  <div class="col-md-4">
    <SelectPaises :titulo="titulo ? titulo : 'País'" :reload="reloadComponent" :pais_select="dataPais.pais" @onSetPais="setPais($event)"/>
  </div>

  <div class="col-md-4" v-if="resetFieldTypeHead">
    <div class="form-floating">
      <Typeahead
        id="typeahead_estados"
        placeholder="Estado / Provincia"
        :items="estados"
        v-model="dataPais.estado"
        @selected="selectEstado"
      />
    </div>
  </div>

  <div class="col-md-4" v-if="resetFieldTypeHead">
    <div class="form-floating">
      <Typeahead
        id="typeahead_ciudades"
        placeholder="Ciudad / Distrito"
        :items="ciudades"
        v-model="dataPais.ciudad"
        @selected="selectCiudad"
      />
    </div>
  </div>

  </div>
</div>
</template>

<script setup>
import {ref, reactive, onMounted, watch} from 'vue'
import {getEstados, getCiudades} from '@/helpers'
import SelectPaises from '@/components/dashboard/selectPaises.vue'
const props = defineProps({
    titulo: null,
    data: {type: Object, default: []} ,
    reload: null
})
const resetFieldTypeHead = ref(true)
const estados = ref([])
const ciudades = ref([])
const dataPais = reactive({
    pais: props.data.pais ? props.data.pais : '',
    estado: props.data.estado ? props.data.estado : '',
    ciudad: props.data.ciudad ? props.data.ciudad : ''
})
const emit = defineEmits(['paises_select'])
const reloadComponent = ref(null)


onMounted(async () => {
  emit('paises_select', dataPais)
})

/**** Funcionalidad paises/estados/ciudades */
const setPais = (e) => {
  dataPais.pais = e.pais
  obtenerEstados()
}

const selectEstado = async (e) => {
  dataPais.estado = e
  await obtenerCiudades(e)
  document.querySelector("#typeahead_ciudades").focus()
  emit('paises_select', dataPais)
}

const selectCiudad = (e) => {
  dataPais.ciudad = e
  emit('paises_select', dataPais)
}

// Emitir también cuando el usuario escribe libremente sin seleccionar del dropdown
watch(() => dataPais.estado, (val) => {
  emit('paises_select', { ...dataPais, estado: val })
})

watch(() => dataPais.ciudad, (val) => {
  emit('paises_select', { ...dataPais, ciudad: val })
})

const obtenerEstados = async () => {
  if(!dataPais.pais){
    return
  }
  const data = await getEstados(dataPais.pais)
  estados.value = data.array
  document.querySelector("#typeahead_estados").focus()
  emit('paises_select', dataPais)
}
  
const obtenerCiudades = async (estado) => {
  if(!dataPais.pais){
    return
  }
  const data = await getCiudades(estado)
  ciudades.value = data.array
  emit('paises_select', dataPais)
}
/*************************/

watch(() => props.reload, data => {
  if(data){
    reloadComponent.value = Date.now()
  }
})
</script>
